(function () {
  if (window.__ozSwatchesSliderInitialized) {
    window.__ozSwatchesSliderInitAll?.();
    return;
  }
  window.__ozSwatchesSliderInitialized = true;

  function isVisible(element) {
    return element && element.offsetParent !== null && element.clientWidth > 0;
  }

  function hasOverflow(viewport) {
    if (!isVisible(viewport)) return false;

    const track = viewport.querySelector('.oz-swatches-slider__track');
    if (!track) return false;

    return Math.ceil(track.getBoundingClientRect().width) > Math.floor(viewport.clientWidth);
  }

  function updateSlider(slider) {
    const viewport = slider.querySelector('[data-oz-swatches-viewport]');
    if (!viewport) return;

    slider.classList.toggle('is-scrollable', hasOverflow(viewport));
  }

  function scheduleUpdate(slider) {
    updateSlider(slider);
    window.requestAnimationFrame(() => updateSlider(slider));
    window.setTimeout(() => updateSlider(slider), 100);
    window.setTimeout(() => updateSlider(slider), 500);
  }

  function bindSlider(slider) {
    if (slider.__ozSwatchesSliderBound) return;
    slider.__ozSwatchesSliderBound = true;

    const viewport = slider.querySelector('[data-oz-swatches-viewport]');
    if (!viewport) return;

    const refresh = () => scheduleUpdate(slider);

    viewport.addEventListener('scroll', () => updateSlider(slider), { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(refresh);
      resizeObserver.observe(viewport);

      const track = viewport.querySelector('.oz-swatches-slider__track');
      if (track) resizeObserver.observe(track);

      slider.__ozSwatchesSliderResizeObserver = resizeObserver;
    }

    const optionSelector = slider.closest('.product-form__option-selector');
    if (optionSelector && typeof MutationObserver !== 'undefined') {
      const mutationObserver = new MutationObserver(refresh);
      mutationObserver.observe(optionSelector, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
        subtree: true,
      });
      slider.__ozSwatchesSliderMutationObserver = mutationObserver;
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-oz-swatches-slider]').forEach(bindSlider);
  }

  window.__ozSwatchesSliderInitAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
